import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type CommentsTranslations = {
  [lang: string]: Translation;
};

export const commentsTranslations: CommentsTranslations = {
  en,
};
